import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import forsaLogo from "../../../../statics/img/forsaLogo.png"
import { Forsa } from './lib';
import {
  getInvoice,
  getInstallments,
  payForsa,
  sendOTP,
  reSendOTP
} from './invoiceService';
import axios from 'axios';
import { appConfig } from '../../../tools/AppConfig';
import { getProductInstallments,payForsaProduct, productSendOTP, productReSendOTP } from './productService';
import {
  calculateAdminFees,
  calculateMonthlyInstallment,
  calculateFinancedAmount,
} from './utils';
import styles from './forsa.module.scss';

const COUNTRY_URL = appConfig.getServerUrl();

export default function FlashForsa(props) {
  const [currency, setCurrency] = useState("");
  const [amount, setAmount] = useState("0");
  const [isDownPayment, setIsDownPayment] = useState(false);
  const [reference, setReference] = useState('');
  const [paymentKey, setPaymentKey] = useState('');
  const [forsaPaymentKey, setForsaPaymentKey] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [errorMessage, setErrorMessage] = useState('');
  const [installmentData, setInstallmentData] = useState([]);
  const [pureInstallmentData, setPureInstallmentData]= useState([]);
  const [selectedOfferId, setSelectedOfferId] = useState();
  const [brand_id, setBrandId] = useState();
  const [offers, setOffers] = useState([]);

  useEffect(() => {
    setCurrency(props.userData['order_currency']);
    if(props.sourcePage ==="product"){
      setAmount(props.userData['amount'].toString());
      handleGetProduct();

    }else{
    setAmount(props.userData['order_amount_egp'].toString());
    handleGetInvoice();
    }
  }, []);

  const handleGetInvoice = async()=>{
    const res = await getInvoice(props.userData.token);
    setForsaPaymentKey(res.data['forsa_payment_key']);
    await getPlansData(0,res.data['forsa_payment_key']);
  }
  const handleGetProduct = async ()=>{
    await getPlansData(0,props.userData.token);
  }
  const changeDownPayment = (downPayment)=>{
  const list = pureInstallmentData.map(
    (item) => {
      const installmentAmount = calculateMonthlyInstallment(
        amount,
        downPayment,
        item.months,
        item.interest_rate
      );
      const adminFees = calculateAdminFees(
        amount,
        item.admin_fees.value,
        downPayment
      );
      const financedAmount = calculateFinancedAmount(amount, downPayment);
      return {
        id: item.id,
        amount: installmentAmount,
        months: item.months,
        extra: {
          categoryId: item.category.id,
          adminFees: adminFees,
          financedAmount: financedAmount,
        },
      };
    }
  );
  setInstallmentData(list);
  }
  const getPlansData = async (downPayment = '0', paymentToken, offerId) => {  
      if(props.sourcePage ==="product"){
        const amount = props.userData['amount'].toString();
        if(paymentToken){
          const res = await getProductInstallments(props.userData.integrations['FORSA'],paymentToken,parseInt(props.userData['amount']),offerId);
          setPureInstallmentData(res.data.installment_data);
          setBrandId(res.data.brand_id)
          if(res.data.offers){
            setOffers(res.data.offers);
          }
          if(Object.hasOwn(res.data,'has_online_downpayment')){
            setIsDownPayment(res.data.has_online_downpayment);
          }
          const list = res.data.installment_data.map(
            (item) => {
              const installmentAmount = calculateMonthlyInstallment(
                amount,
                downPayment,
                item.months,
                item.interest_rate
              );
              const adminFees = calculateAdminFees(
                amount,
                item.admin_fees.value,
                downPayment
              );
              const financedAmount = calculateFinancedAmount(amount, downPayment);
              return {
                id: item.id,
                amount: installmentAmount,
                months: item.months,
                extra: {
                  categoryId: item.category.id,
                  adminFees: adminFees,
                  financedAmount: financedAmount,
                },
              };
            }
          );
          setInstallmentData(list);
        }
        
      }
      else{
        const amount = props.userData['order_amount_egp'].toString();
        if(paymentToken){
        const res = await getInstallments(props.userData.integration_ids['FORSA'],paymentToken,offerId);
        if(res.data.offers){
          setOffers(res.data.offers);
        }
        if(Object.hasOwn(res.data,'has_online_downpayment')){
          setIsDownPayment(res.data.has_online_downpayment);
        }
        setPureInstallmentData(res.data.installment_data);
        setBrandId(res.data.brand_id)
        const list = res.data.installment_data.map(
          (item) => {
            const installmentAmount = calculateMonthlyInstallment(
              amount,
              downPayment,
              item.months,
              item.interest_rate
            );
            const adminFees = calculateAdminFees(
              amount,
              item.admin_fees.value,
              downPayment
            );
            const financedAmount = calculateFinancedAmount(amount, downPayment);
            return {
              id: item.id,
              amount: installmentAmount,
              months: item.months,
              extra: {
                categoryId: item.category.id,
                adminFees: adminFees,
                financedAmount: financedAmount,
              },
            };
          }
        );
        setInstallmentData(list);
      }
    }
  };
  const handleChangeOffer =  (
    payment_token,
    order_id,
    integration_id,
    offer
  ) => {
      setLoading(true);
      if(offer){
        setSelectedOfferId(offer.id);
        getPlansData(0,payment_token,offer.id);
      }
      else{
        getPlansData(0,payment_token);
      }

      setLoading(false);
  };

  const handlePaySubmit = async (
    plan,
    phone,
    downPayment
  ) => {
    setLoading(true);
     if(props.sourcePage ==="product"){
      const res = await payForsaProduct(
        phone,
        downPayment,
        plan.extra.categoryId.toString(),
        plan.id,
        props.userData.token,
        props.userData.integrations['FORSA'],
        props.userData,
        props.deliveryData,
        pureInstallmentData,
        props.quantity,
        props.deliveryNeed
      );
 
      if (res.status === 200) {
        setReference(res.data.reference);
        setPaymentKey(res.data.pmk)
        setStep(2);
      } else if (res.status === 400) {
       props.setReqComplete({head: 'Something went wrong', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else if (res.status === 401) {
       //console.log("payment expired");
       props.setReqComplete({head: 'Something went wrong', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else {
        props.setReqComplete({head: 'Something went wrong', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      }
     }else{
      const res = await payForsa(
        phone,
        downPayment,
        plan.extra.categoryId.toString(),
        plan.id,
        props.userData.token,
        props.userData.integration_ids['FORSA'],
        props.userData,
        props.deliveryData,
      );
 
      if (res.status === 200) {
        setReference(res.data.reference);
        setPaymentKey(res.data.pmk)
        setStep(2);
      } else if (res.status === 400) {
        props.setReqComplete({head: 'Something went wrong', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else if (res.status === 401) {
       props.setReqComplete({head: 'Something went wrong', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else {
       props.setReqComplete({head: 'Something went wrong', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      }
     }
         setLoading(false);
  };

  const handleOTPResend = async () => {
    setLoading(true);
    const res = await reSendOTP(forsaPaymentKey, reference);
    if (res.status === 200) {
      //
    } else if (res.status === 400) {
      console.log("error")
    } else if (res.status === 401) {
      console.log("error")
        } else {
          console.log("error")
        }
    setLoading(false);
  };

  const handleOTPSubmit = async (otp) => {
    if(props.sourcePage ==="product"){
      const res = await productSendOTP(otp, paymentKey, reference);
      if (res.status === 200 || 201) {
        if(res.data.success ==="true"){
          if(res.data & res.data['data.message']){
            props.setReqComplete({head: 'Payment Successful', body: res.data['data.message']});
        }else{
            props.setReqComplete({head: 'Payment Successful', body:'Congratulations, your transaction completed successfully.'});
        }
        }
        else{
          props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});

        }
      } else if (res.status === 400) {
        props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else if (res.status === 401) {
        props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else {
        props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      }
    }
    else{
      const res = await sendOTP(otp, paymentKey, reference);
      if (res.status === 200) {
        if(res.data.success ==="true"){
          if(res.data & res.data['data.message']){
            props.setReqComplete({head: 'Payment Successful', body: res.data['data.message']});
        }else{
            props.setReqComplete({head: 'Payment Successful', body:'Congratulations, your transaction completed successfully.'});
        }
        }
        else{
          props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
        }
      } else if (res.status === 400) {
        props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else if (res.status === 401) {
        props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      } else {
        props.setReqComplete({head: 'Transaction declined', body: 'Please try again later. If this problem persists, please contact your service provider.'});
      }
    }

  };

  return (
    <div className={styles['container']}>
        <div className='title'>
      <img
        className='title-icon'
        src={forsaLogo}
        alt="Forsa logo"
        width="150px"
        style={{marginBottom:20}}
      />
    </div>

      <Forsa
        step={step}
        plans={installmentData}
        offers={offers}
        currency={currency}
        loading={loading}
        isDownPayment={isDownPayment}
        errorMessage={errorMessage}
        userData={props.userData}
        brandId={brand_id}
        handleDownPaymentChange={changeDownPayment}
        handleChangeOffer={handleChangeOffer}
        handleOTPResend={handleOTPResend}
        handlePaySubmit={handlePaySubmit}
        handleOTPSubmit={handleOTPSubmit}
        customStyle={{}}
      />
    </div>
  );
}
